import { Box, Theme, useMediaQuery } from '@mui/material'
import Container from 'components/Container'
import {
  ButtonSkeleton,
  LogoSkeleton,
  ModelSkeleton,
  PillsContainer,
  PillsSkeleton,
  SkeletonContainer,
  StatSkeleton,
  StatSkeletonContainer,
} from './styled'

const LoadingState = () => {
  const upSm = useMediaQuery<Theme>((theme) => theme.breakpoints.up('sm'))
  return (
    <Container sx={{ minHeight: 'calc(100vh - 80px)' }}>
      <SkeletonContainer>
        <Box component="div">
          <LogoSkeleton variant="rectangular" />
          <StatSkeletonContainer>
            {[...Array(5)].map((_, index) => (
              <StatSkeleton key={index} />
            ))}
          </StatSkeletonContainer>
          <ButtonSkeleton />
        </Box>
        <ModelSkeleton variant="rectangular" />
      </SkeletonContainer>
      <PillsContainer>
        {[...Array(upSm ? 5 : 3)].map((_, index) => (
          <PillsSkeleton variant="rectangular" key={index} />
        ))}
      </PillsContainer>
    </Container>
  )
}

export default LoadingState
